import type { ActionType } from "typesafe-actions";
import { getType } from "typesafe-actions";

import type { MainSearchSource } from "@/shop/api/mainSearch";

import * as MainSearchActions from "../actions";
import type { IMainSearchFilterState } from "../types";

type MainSearchFilterActionType =
  | ActionType<typeof MainSearchActions.setFilterSetting>
  | ActionType<typeof MainSearchActions.fetchFilterDefinitionStart>
  | ActionType<typeof MainSearchActions.fetchFilterDefinitionSuccess>
  | ActionType<typeof MainSearchActions.fetchFilterDefinitionFail>;

export function createMainSearchFilterReducer(
  source: MainSearchSource
): (state: IMainSearchFilterState, action: MainSearchFilterActionType) => IMainSearchFilterState {
  const initialState: IMainSearchFilterState = {
    source,
    filterDefinitions: [],
    filterSetting: [],
    hasError: false,
    isFetching: false
  };
  return function mainSearchFilterReducer(state = initialState, action) {
    if (action.meta?.collection === state.source) {
      switch (action.type) {
        case getType(MainSearchActions.fetchFilterDefinitionStart):
          return { ...state, isFetching: true };
        case getType(MainSearchActions.fetchFilterDefinitionFail):
          return { ...state, isFetching: false, hasError: true };
        case getType(MainSearchActions.fetchFilterDefinitionSuccess):
          return {
            ...state,
            isFetching: false,
            filterDefinitions: action.payload
          };
        case getType(MainSearchActions.setFilterSetting):
          return { ...state, filterSetting: action.payload };
        default:
          return state;
      }
    } else {
      return state;
    }
  };
}
